import React from 'react';
import { Helmet } from 'react-helmet';
import PaidMediaCampaigns from './PaidMediaCampaign';

const PaidMediaCampaignsPage = () => (
  <>
    <Helmet>
      <title>Paid Media Campaigns | MilaajBrandset</title>
      <meta
        name="description"
        content="Drive targeted traffic and maximize ROI with MilaajBrandset's data-driven paid media campaigns. We create and manage effective ads across multiple platforms to ensure your budget is utilized efficiently."
      />
      <meta
        name="keywords"
        content="Paid Media Campaigns, Precision Targeting, Cost Optimization, Comprehensive Tracking, Creative Designs, MilaajBrandset"
      />
      <meta property="og:title" content="Paid Media Campaigns | MilaajBrandset" />
      <meta
        property="og:description"
        content="Drive targeted traffic and maximize ROI with MilaajBrandset's data-driven paid media campaigns. We create and manage effective ads across multiple platforms to ensure your budget is utilized efficiently."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.milaajbrandset.com/paid-media-campaigns" />
      <meta property="og:image" content="https://www.milaajbrandset.com/images/paid-media-og-image.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Paid Media Campaigns | MilaajBrandset" />
      <meta
        name="twitter:description"
        content="Drive targeted traffic and maximize ROI with MilaajBrandset's data-driven paid media campaigns. We create and manage effective ads across multiple platforms to ensure your budget is utilized efficiently."
      />
      <meta name="twitter:image" content="https://www.milaajbrandset.com/images/paid-media-twitter-image.jpg" />
    </Helmet>
    <PaidMediaCampaigns />
  </>
);

export default PaidMediaCampaignsPage;